import { useAccountSetting } from "@/settings/account-settings-context";

/** Ключ браузерного хранилища: выбор «свёрнуто/развёрнуто» (ТЗ §56 п. 1 — в браузере, не на сервере). */
export const SIDEBAR_STORAGE_KEY = "screener.sidebar";

const EXPANDED = "expanded";

/**
 * Доступ к хранилищу — функцией, а не готовым объектом: при запрещённых
 * данных сайта бросает уже сам геттер `window.localStorage`, и вызов обязан
 * стоять внутри той же защиты, что и `getItem`.
 */
type StorageAccess<K extends keyof Storage> = () => Pick<Storage, K> | null;

/**
 * Развёрнута ли панель по сохранённому выбору. По умолчанию панель свёрнута
 * в полосу значков (§88 п. 6): развёрнута она только по записанному выбору
 * «развёрнута», и такой выбор уважается. Чтение обёрнуто: в приватном окне и
 * при запрещённых данных сайта обращение бросает, и недоступное хранилище не
 * должно ронять интерфейс — панель тогда свёрнута, как у нового пользователя.
 */
export function readSidebarOpen(storage: StorageAccess<"getItem">): boolean {
  try {
    return storage()?.getItem(SIDEBAR_STORAGE_KEY) === EXPANDED;
  } catch {
    return false;
  }
}

/**
 * Выбор панели берётся из настроек аккаунта (§127); подпись прежняя.
 * Возвращает `[open, setOpen]`.
 */
export function useSidebarOpen(): [boolean, (open: boolean) => void] {
  const [store, open] = useAccountSetting("sidebarOpen");
  return [open, store.setSidebarOpen];
}
